export const WORD_SEARCH_POINT_PER_WORD = 1;
export const WORD_SEARCH_ROUND_LIMIT_SECONDS = 60;
export const WORD_SEARCH_ROUND_LIMIT_LABEL = "1 minute";
export const WORD_SEARCH_AUTO_NEXT_ROUND_MS = 3000;
export const WORD_SEARCH_DEFAULT_GRID_CELL_WIDTH = 10;
export const WORD_SEARCH_DEFAULT_GRID_CELL_HEIGHT = 10;
